// extracted by mini-css-extract-plugin
module.exports = {"rowFlex":"_4e6iNhNUpK1XRVoLtZ6LTw==","columnFlex":"WeFqEC5XfH++QAs8Te3fAg==","wrapper":"Ui17b6M4jaWYXXewZrwiNQ==","alignText":"hh4yr10PoPsMf3vpxOdakg=="};